import gql from 'graphql-tag';

const NAME = 'compositions_DealerLocator_activeAfterHoursContactsQuery';

export default gql`
  fragment ContactInfo on AfterHoursContact {
    id
    name
    jobTitle
    primaryPhoneNumber
    secondaryPhoneNumber
  }

  query ${NAME} (
    $dealerId: ID!,
  ) {
    activeAfterHoursContacts(input: { dealerId: $dealerId }) {
      contacts {
        backupContact { ...ContactInfo }
        primaryContact { ...ContactInfo }
        finalContact { ...ContactInfo }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/compositions/DealerLocator/DealerDetails/Contacts/activeAfterHoursContactsQuery.js